import { useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { ControlledTextArea } from "components/inputs";
import { useParams } from "react-router-dom";
import {
  ControlledInput,
  ControlledDateInput,
} from "components/Card/ControlledInput";
import { MaskedInput } from "components/inputs";
import ControlledSelect from "components/inputs/Select/ControlledSelect";
import {
  useGetAmendedReviewByIdQuery,
  usePatchAmendedReviewByIdMutation,
} from "services/ar-screening-api";

const AmendedReviewSection = () => {
  const { reviewId } = useParams<{ reviewId: string }>();
  const [patchAmendedReviewByIdMutation] = usePatchAmendedReviewByIdMutation();

  const { data: review } = useGetAmendedReviewByIdQuery(
    { reviewId },
    { skip: !reviewId },
  );

  const onSave = useCallback(
    async (field: string, value: unknown) => {
      if (!review?.id) return;

      await patchAmendedReviewByIdMutation({
        id: review.id.toString(),
        data: { [field]: value },
      });
    },
    [review?.id, patchAmendedReviewByIdMutation],
  );

  const {
    reset,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    reset({
      explanation: review?.explanation,
      date_received: review?.date_received,
      cms_approval_amount: review?.cms_approval_amount,
      has_greater_than_10_percent_change:
        review?.has_greater_than_10_percent_change,
    });
  }, [review, reset]);

  return (
    <div className="card form audit-and-consulting-card">
      <div className="card__header">Amended Screening 10/10 Review</div>
      <div className="card__children">
        <ControlledDateInput
          control={control}
          label="Date Received"
          name="date_received"
          errors={errors}
          onSave={(value) => onSave("date_received", value)}
        />
        <ControlledSelect
          control={control}
          name="has_greater_than_10_percent_change"
          errors={errors}
          label="> 10% Change"
          onSave={(o) => onSave("has_greater_than_10_percent_change", o?.value)}
          options={[
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ]}
        />
        <ControlledInput
          label="CMS Approval Amount"
          control={control}
          name="cms_approval_amount"
          errors={errors}
          onSave={(value) => onSave("cms_approval_amount", value)}
          componentType={MaskedInput}
          mask="dollar"
        />
        <ControlledTextArea
          name="explanation"
          control={control}
          advancedEdit={true}
          label="Explanation"
          onSave={(value) => onSave("explanation", value)}
          errors={errors}
        />
      </div>
    </div>
  );
};

export default AmendedReviewSection;
